import React, { useState } from 'react'

const LocationCoordsField = ({
  position,
  onLatitudeChange,
  onLongitudeChange,
  invalidLatitude,
  invalidLongitude,
  t
}) => {
  const [showPopover, setShowPopover] = useState(false)
  const [tempLat, setTempLat] = useState('')
  const [tempLng, setTempLng] = useState('')
  const [localError, setLocalError] = useState(null)

  const hasCoords =
    position &&
    position.latitude !== null &&
    position.latitude !== undefined &&
    position.latitude !== '' &&
    position.longitude !== null &&
    position.longitude !== undefined &&
    position.longitude !== ''

  const latNum = hasCoords ? Number(position.latitude) : null
  const lngNum = hasCoords ? Number(position.longitude) : null

  const handleOpenPopover = () => {
    if (hasCoords) {
      const latVal = latNum !== null && !isNaN(latNum) ? latNum.toFixed(6) : (position?.latitude ?? '')
      const lngVal = lngNum !== null && !isNaN(lngNum) ? lngNum.toFixed(6) : (position?.longitude ?? '')
      setTempLat(latVal)
      setTempLng(lngVal)
    } else {
      setTempLat('')
      setTempLng('')
    }
    setLocalError(null)
    setShowPopover(true)
  }

  const handleCancel = () => {
    setShowPopover(false)
    setLocalError(null)
  }

  const handleApply = () => {
    const parsedLat = parseFloat(tempLat)
    const parsedLng = parseFloat(tempLng)

    if (isNaN(parsedLat) || isNaN(parsedLng)) {
      setLocalError(t ? t('GLOBAL.INVALID_COORDINATES', { defaultValue: 'Please enter valid coordinates' }) : 'Please enter valid coordinates')
      return
    }

    if (parsedLat < -90 || parsedLat > 90) {
      setLocalError(t ? t('GLOBAL.INVALID_LATITUDE', { defaultValue: 'Latitude must be between -90 and 90' }) : 'Latitude must be between -90 and 90')
      return
    }

    if (parsedLng < -180 || parsedLng > 180) {
      setLocalError(t ? t('GLOBAL.INVALID_LONGITUDE', { defaultValue: 'Longitude must be between -180 and 180' }) : 'Longitude must be between -180 and 180')
      return
    }

    if (onLatitudeChange) {
      onLatitudeChange(parsedLat)
    }
    if (onLongitudeChange) {
      onLongitudeChange(parsedLng)
    }
    setShowPopover(false)
    setLocalError(null)
  }

  const coordDisplay = `${latNum !== null && !isNaN(latNum) ? latNum.toFixed(4) : position?.latitude}, ${lngNum !== null && !isNaN(lngNum) ? lngNum.toFixed(4) : position?.longitude}`

  return (
    <div className='location-coords-field'>
      <div className='location-coords-field__header'>
        <span className='location-coords-field__label'>
          {t ? t('GLOBAL.LOCATION_COORDINATES', { defaultValue: 'Location coordinates' }) : 'Location coordinates'}
        </span>
      </div>

      {!hasCoords
        ? (
          <div className='location-coords-field__not-set'>
            <span className='location-coords-field__placeholder'>
              {t ? t('GLOBAL.NOT_SET_HINT', { defaultValue: 'Not set (click on map)' }) : 'Not set (click on map)'}
            </span>
            <button
              type='button'
              className='location-coords-field__toggle'
              onClick={handleOpenPopover}
            >
              {t ? t('GLOBAL.ENTER_MANUALLY', { defaultValue: 'Enter coordinates' }) : 'Enter coordinates'}
            </button>
          </div>
          )
        : (
          <a
            href='#coordinates'
            className='location-coords-field__link'
            onClick={(e) => {
              e.preventDefault()
              handleOpenPopover()
            }}
            title='Click to edit numeric coordinates'
          >
            {coordDisplay}
          </a>
          )}

      {showPopover && (
        <div className='location-coords-field__popover'>
          <h4 className='location-coords-field__popover-title'>
            {t ? t('GLOBAL.EDIT_COORDINATES', { defaultValue: 'Edit Coordinates' }) : 'Edit Coordinates'}
          </h4>

          <div className='location-coords-field__popover-grid'>
            <div className='location-coords-field__popover-field'>
              <label htmlFor='coords-lat-input'>
                {t ? t('GLOBAL.LATITUDE', { defaultValue: 'Latitude' }) : 'Latitude'}
              </label>
              <input
                id='coords-lat-input'
                type='number'
                step='any'
                min={-90}
                max={90}
                value={tempLat}
                onChange={(e) => setTempLat(e.target.value)}
                placeholder='0.000000'
                autoFocus
              />
            </div>

            <div className='location-coords-field__popover-field'>
              <label htmlFor='coords-lng-input'>
                {t ? t('GLOBAL.LONGITUDE', { defaultValue: 'Longitude' }) : 'Longitude'}
              </label>
              <input
                id='coords-lng-input'
                type='number'
                step='any'
                min={-180}
                max={180}
                value={tempLng}
                onChange={(e) => setTempLng(e.target.value)}
                placeholder='0.000000'
              />
            </div>
          </div>

          {(localError || invalidLatitude || invalidLongitude) && (
            <span className='location-coords-field__popover-error'>
              {localError || invalidLatitude || invalidLongitude}
            </span>
          )}

          <div className='location-coords-field__popover-actions'>
            <button
              type='button'
              className='location-coords-field__btn-cancel'
              onClick={handleCancel}
            >
              {t ? t('GLOBAL.CANCEL', { defaultValue: 'Cancel' }) : 'Cancel'}
            </button>
            <button
              type='button'
              className='location-coords-field__btn-apply'
              onClick={handleApply}
            >
              {t ? t('GLOBAL.APPLY', { defaultValue: 'Apply' }) : 'Apply'}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default LocationCoordsField
